import { PageHeader } from 'antd';
import React, { FC } from 'react';
import { history } from '../../core/components/App/history';

export const DirectoryProfilesHeader: FC<{}> = (): JSX.Element => (
  <PageHeader onBack={() => history.goBack()} subTitle="- Profiles" title="Provider Directory" />
);
